import React from "react";
import { TrendingUp, LineChart, Home, Layers, Wallet } from "lucide-react";

export default function MetricsPanel({ metrics, disclaimer }) {
  if (!metrics || !metrics.show) return null;
  const items = [
    { icon: TrendingUp, label: "Projected Yield", value: metrics.projected_yield },
    { icon: LineChart, label: "Est. Capital Growth", value: metrics.capital_growth },
    { icon: Home, label: "Target Rental", value: metrics.target_rental },
    { icon: Layers, label: "Investor Strategies", value: metrics.investor_strategies },
    { icon: Wallet, label: "Entry / Payment Position", value: metrics.entry_position },
  ].filter((i) => i.value);

  if (!items.length) return null;

  return (
    <div data-testid="metrics-panel" className="border border-gold/20 bg-seablue/20">
      <div className="grid grid-cols-2 divide-x divide-y divide-gold/10 md:grid-cols-3 lg:grid-cols-5 lg:divide-y-0">
        {items.map((it, i) => (
          <div key={i} className="p-6" data-testid={`metric-${i}`}>
            <it.icon size={16} className="text-gold" />
            <div className="mt-3 font-sans text-[10px] tracking-luxe uppercase text-softgrey/70">{it.label}</div>
            <div className="mt-2 font-mono text-lg text-warmwhite">{it.value}</div>
          </div>
        ))}
      </div>
      {disclaimer && (
        <p className="border-t border-gold/10 px-6 py-4 font-sans text-[11px] italic leading-relaxed text-softgrey/60">
          {disclaimer}
        </p>
      )}
    </div>
  );
}
